// extracted by mini-css-extract-plugin
export var container = "imageTextList-module--container--83251";
export var containerImage = "imageTextList-module--containerImage--a03b1";
export var containerText = "imageTextList-module--containerText--c2651";
export var divRoot = "imageTextList-module--divRoot--d960d";
export var image = "imageTextList-module--image--de3e1";
export var root = "imageTextList-module--root--b54c3";
export var title = "imageTextList-module--title--7f95b";